import { createContext } from 'react';

interface UnorderedListContextProps {
  depth: number;
}

export const UnorderedListContext = createContext<UnorderedListContextProps>({
  depth: 0,
});
